interface ProcessEnv {
    NODE_ENV: 'development' | 'production';
    CONFIG_ENV: 'development' | 'production';
    CONFIG_ENDPOINT: string;
    USE_LOCAL_CONFIG: string;
    TENANT: string;
}

export const getProcessEnv = <T extends keyof ProcessEnv>(envVar: T, defaultValue?: ProcessEnv[T]): ProcessEnv[T] =>
    // @ts-ignore
    (process.env[envVar] as any) || defaultValue || null;

export const isDevNodeEnv = () => getProcessEnv('NODE_ENV') === 'development';

export const isProdNodeEnv = () => getProcessEnv('NODE_ENV') === 'production';
